module.exports = __webpack_public_path__ + "img/yellow.a16801e4.jpg";